import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function KeepAlive() {
    useEffect(() => {
        // Invoke the keep-alive function to prevent the Supabase free tier database from pausing.
        // This function makes a simple DB query.
        const pingSupabase = async () => {
            try {
                await supabase.functions.invoke('keep-alive');
            } catch (error) {
                console.error('Keep-alive ping failed:', error);
            }
        };

        // Ping immediately on mount
        pingSupabase();

        // Ping every 15 minutes while the app is open
        const interval = setInterval(pingSupabase, 1000 * 60 * 15);

        return () => clearInterval(interval);
    }, []);

    return null;
}
